module.exports = __webpack_public_path__ + "static/icons/icon_error.7c2fed2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cvc/icon_error.svg
// module id = Zxtu
// module chunks = 1